import { HomePage } from "@pages/outside/HomePage";
import { LoginPage } from "@features/auth";
import TestPage from "@pages/test";
//private
import { EntryPage, EntryTest } from "@features/entry";

import { Screenout, Complete } from "@features/endpages";

import OutsidePageLayout from "@layout/containers/OutsidePageLayout";

const entry = [
  {
    path: "/entry/:data",
    element: <EntryTest />,
    exact: true,
  },
  {
    path: "/entrytest/:data",
    element: <EntryTest />,
    exact: true,
  },
];

const endRoutes = [
  {
    path: "/end/screenout",
    element: <Screenout />,
    exact: true,
  },
  {
    path: "/end/complete",
    element: <Complete />,
    exact: true,
  },
];

const publicRoutes = [
  ...entry,
  ...endRoutes,
  {
    path: "/",
    element: <HomePage />,
    exact: true,
  },
  {
    path: "/login",
    element: (
      <OutsidePageLayout>
        <LoginPage />
      </OutsidePageLayout>
    ),
    exact: true,
  },
  {
    path: "/test",
    element: <TestPage />,
    exact: true,
  },
];

export default publicRoutes;
